import { buildQueryString } from 'utils/queryString';

export function getProviderPath(providerId: string, query: Record<string, any>) {
  return `/hotel/voice/${providerId}?${buildQueryString(query)}`;
}
